import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "app-edit-qtb-dialog",
    templateUrl: "./edit-qtb-dialog.component.html",
    styleUrls: ["./edit-qtb-dialog.component.scss"],
    standalone: false,
})
export class EditQtbDialogComponent implements OnInit {
    public editReason = "";

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<EditQtbDialogComponent>,
    ) {}

    ngOnInit(): void {}

    onCancel() {
        this.dialogRef.close({ data: { confirmed: false } });
    }

    onConfirm() {
        this.dialogRef.close({ data: { confirmed: true, reason: this.editReason } });
    }
}
